import { render } from "./marqueeWrapper.vue?vue&type=template&id=5ed11098"
import script from "./marqueeWrapper.vue?vue&type=script&lang=js"
export * from "./marqueeWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__